// PaymentButton.jsx
import React, { useEffect, useState } from 'react';

const PaymentButton = () => {
  const [sdkReady, setSdkReady] = useState(() => typeof window !== 'undefined' && Boolean(window.MonnifySDK));
  const [sdkError, setSdkError] = useState('');

  useEffect(() => {
    if (window.MonnifySDK) {
      setSdkReady(true);
      return undefined;
    }

    let script = document.getElementById('monnify-sdk');
    let shouldRemoveScript = false;

    const handleLoad = () => {
      setSdkReady(true);
      setSdkError('');
    };

    const handleError = () => {
      setSdkError('Unable to load Monnify right now. Please refresh and try again.');
      setSdkReady(false);
    };

    if (!script) {
      script = document.createElement('script');
      script.id = 'monnify-sdk';
      script.src = 'https://sdk.monnify.com/plugin/monnify.js';
      script.async = true;
      document.body.appendChild(script);
      shouldRemoveScript = true;
    }

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    return () => {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);

      if (shouldRemoveScript && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const payWithMonnify = () => {
    if (!window.MonnifySDK) {
      setSdkError('Monnify is still loading. Please wait a moment and try again.');
      return;
    }

    window.MonnifySDK.initialize({
      amount: 1000, // Amount to be paid
      currency: 'NGN', // Currency
      reference: new Date().getTime().toString(), // Unique reference
      customerFullName: 'John Doe', // Customer's full name
      customerEmail: 'johndoe@example.com', // Customer's email
      apiKey: 'MK_TEST_WRRPQH8TRX', // Replace with your Monnify API key
      contractCode: '6759572933', // Replace with your Monnify contract code
      paymentDescription: 'Payment for services',
      metadata: {
        customData: 'Additional info', // Additional metadata if needed
      },
      onLoadStart: () => {
        console.log('Monnify SDK loading started');
      },
      onLoadComplete: () => {
        console.log('Monnify SDK is ready');
      },
      onComplete: (response) => {
        console.log('Transaction complete:', response);
        // Handle post-transaction logic here
      },
      onClose: (data) => {
        console.log('Payment modal closed:', data);
        // Handle modal close event here
      },
    });
  };

  return (
    <div className="flex flex-col items-center justify-center mx-auto my-56 space-y-4">
      <button
        onClick={payWithMonnify}
        disabled={!sdkReady}
        className="bg-blue-500 hover:bg-blue-700 disabled:bg-blue-300 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded flex justify-center items-center"
      >
        {sdkReady ? 'Pay with Monnify' : 'Loading Payment...'}
      </button>
      {sdkError && <p className="text-sm text-red-600">{sdkError}</p>}
    </div>
  );
};

export default PaymentButton;
